import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import UndoIcon from "@material-ui/icons/Undo";
import React from "react";
import moment from "moment";
import { Pagination } from "../../../../components/shared/Pagination/Pagination";

const statusToIcon = {
  refund: <UndoIcon fontSize="small" />,
  pending: <MoreHorizIcon fontSize="small" />,
  complete: <CheckIcon fontSize="small" />,
  cancelled: <CloseIcon fontSize="small" />,
};

const statusToValue = {
  refund: "refund",
  pending: "pending",
  complete: "paid",
  cancelled: "cancelled",
};

const statusStyles = {
  refund: "bg-gray100 text-gray700",
  pending: "bg-primary50 text-primary700",
  complete: "bg-success50 text-success700",
  cancelled: "bg-error50 text-error700",
};

const PurchaseHistoryTable = ({
  currentPage,
  onPageChange,
  pageNumber,
  purchaseHistory,
}) => {
  return (
    <div className="overflow-x-auto text-left rounded-xl border border-gray200">
      <table className="border-none overflow-hidden border-collapse border-spacing-0 min-w-full">
        <thead>
          <tr className="bg-gray50 text-xs text-left text-gray600">
            <th className="py-2 px-2">Order</th>
            <th className="py-2 px-2">Price</th>
            <th className="py-2 px-2">Status</th>
            <th className="py-2 px-2">Date</th>
          </tr>
        </thead>
        <tbody className="border-none">
          {purchaseHistory.map((item) => (
            <tr
              key={item.id}
              className="border-x-0 border-b-0 border-t border-gray200"
            >
              <td className="py-2 px-2">
                {item.creditCount}{" "}
                {item.creditType === "reportCredits"
                  ? "Swing Score"
                  : "Student"}{" "}
                Credits
              </td>
              <td className="py-2 px-2">${item.amount}</td>
              <td className="py-2 px-2">
                <span
                  className={`flex items-center gap-2 px-3 py-1 rounded-full w-fit text-xs font-medium capitalize ${
                    statusStyles[item.status.toLowerCase()]
                  }`}
                >
                  {statusToIcon[item.status.toLowerCase()]}{" "}
                  {statusToValue[item.status]}
                </span>
              </td>
              <td className="py-2 px-2">
                {moment(item.createdAt).format("MM-DD-YYYY")}
              </td>
            </tr>
          ))}
        </tbody>

        <tfoot>
          <tr className="border-x-0 border-b-0 border-t border-gray200">
            <td className="py-2 px-2" colSpan="4">
              <Pagination
                currentPage={currentPage}
                pageNumber={pageNumber}
                onPageChange={onPageChange}
              />
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default PurchaseHistoryTable;
